const translations = {
  de: {
    'mirador-dl-plugin': {
      close: 'Schließen',
      download: 'Download',
      other_download: 'Andere Download-Optionen',
      whole_image: 'Gesamtes Bild ({{width}} x {{height}}px)',
      whole_image_labeled: 'Gesamtes Bild ({{label}})',
      zoomed_region: 'Aktueller Bildausschnitt ({{width}} x {{height}}px)',
    },
  },
  en: {
    'mirador-dl-plugin': {
      close: 'Close',
      download: 'Download',
      other_download: 'Other download options',
      whole_image: 'Whole image ({{width}} x {{height}}px)',
      whole_image_labeled: 'Whole image ({{label}})',
      zoomed_region: 'Zoomed region ({{width}} x {{height}}px)',
    },
  },
  et: {
    'mirador-dl-plugin': {
      close: 'Sulge',
      download: 'Lae alla',
      other_download: 'Teised allalaadimise valikud',
      whole_image: 'Kogu pilt ({{width}} x {{height}}px)',
      whole_image_labeled: 'Kogu pilt ({{label}})',
      zoomed_region: 'Suurendatud piirkond ({{width}} x {{height}}px)',
    },
  },
  fr: {
    'mirador-dl-plugin': {
      close: 'Fermer',
      download: 'Télécharger',
      other_download: 'Autres options de téléchargement',
      whole_image: 'Image entière ({{width}} x {{height}}px)',
      whole_image_labeled: 'Image entière ({{label}})',
      zoomed_region: 'Région zoomée ({{width}} x {{height}}px)',
    },
  },
};

export default translations;
